module.exports = __webpack_public_path__ + "static/media/badge.97f754ae.svg";